// @ts-nocheck

// libs
import axios from "src/libs/axios";
import useSWR from "swr";

// types
import { TClinicDetails } from "src/types";

// consts
import { ENDPOINTS } from "src/constants/endpoints";

const {
  GET: { reviews },
} = ENDPOINTS;

// eslint-disable-next-line import/prefer-default-export
export const useReviews = (id: number, params = {}, defaultData = null) => {
  const initialData = defaultData ? { initialData: { data: defaultData } } : null;
  // need to refactor this later
  const ratingMapping = {
    0: 5,
    1: 4,
    2: 3,
    3: 2,
    4: 1,
  };

  const paramsString = params.rating
    .map((item, index) => (item ? `rating=${ratingMapping[index]}` : ""))
    .filter(Boolean)
    .join("&");

  const ratingString = paramsString ? `&${paramsString}` : "";

  const { data, error } = useSWR(
    `${reviews}?clinic=${id}&_start=0${ratingString}`,
    axios,
    initialData,
  );

  return {
    reviews: data?.data,
    isLoading: !error && !data,
    isError: error,
  };
};
